import { render } from "./SeccionDeLeyenda.vue?vue&type=template&id=0f37345a&scoped=true&ts=true"
import script from "./SeccionDeLeyenda.vue?vue&type=script&lang=ts"
export * from "./SeccionDeLeyenda.vue?vue&type=script&lang=ts"

import "./SeccionDeLeyenda.vue?vue&type=style&index=0&id=0f37345a&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f37345a"]])

export default __exports__